import { Observable } from 'rxjs';
import { IBgxHttpRESTOptionsWithBody } from '../http.interfaces';

/**
 * Interface for http interceptors.
 * Implement the methods you want to be executed in the request pipeline on interception.
 */
export interface IBgxHttpInterceptor {
  handleOptions?: (options: IBgxHttpRESTOptionsWithBody) => IBgxHttpRESTOptionsWithBody;
  handleResponse?: (observable: Observable<any>) => Observable<any>;
}
